import { useState, useEffect } from 'react';
import styles from './index.module.less';
import { Layout, theme } from 'antd';
import Menu from '@/components/Menu';
import Breadcrumb from '@/components/Breadcrumb';
import {
  Service,
  type BaseResponseDto_ManagerDetailResponseTree,
  type ManagerDetailResponseTree,
  type ManagerDetailResponseTreeItem,
} from '@/apis';
import Header from '../Header';
const { Content, Sider } = Layout;

function normalizePermissionTree(
  nodes: ManagerDetailResponseTreeItem[] | null | undefined
): ManagerDetailResponseTreeItem[] {
  if (!Array.isArray(nodes) || nodes.length === 0) return [];
  return nodes.map(node => ({
    ...node,
    children: normalizePermissionTree(node.children ?? []),
  }));
}

interface MainLayoutProps {
  children?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const [permissionTree, setPermissionTree] = useState<
    ManagerDetailResponseTreeItem[]
  >([]);
  const [userInfo, setUserInfo] = useState<ManagerDetailResponseTree>(
    {} as ManagerDetailResponseTree
  );
  const getPermission = () => {
    Service.managerControllerGetPermission()
      .then((res: BaseResponseDto_ManagerDetailResponseTree & { errNo?: number }) => {
        if (res?.errNo !== undefined && res.errNo !== 0) return;
        const data = res?.data;
        if (!data) return;
        setUserInfo(data as ManagerDetailResponseTree);
        let tree: ManagerDetailResponseTreeItem[] | undefined;
        if (Array.isArray((data as ManagerDetailResponseTree).permissionTree)) {
          tree = (data as ManagerDetailResponseTree).permissionTree;
        } else if (Array.isArray((res as { permissionTree?: ManagerDetailResponseTreeItem[] }).permissionTree)) {
          tree = (res as unknown as { permissionTree: ManagerDetailResponseTreeItem[] }).permissionTree;
        } else if (Array.isArray(data)) {
          tree = data as unknown as ManagerDetailResponseTreeItem[];
        }
        if (tree?.length) {
          setPermissionTree(normalizePermissionTree(tree));
        }
      })
      .catch(() => {
        setPermissionTree([]);
      });
  };

  useEffect(() => {
    getPermission();
  }, []);
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header userInfo={userInfo} />
      <Layout>
        <Sider
          width={256}
          className={styles.sider}
          style={{
            background: colorBgContainer,
          }}
        >
          <Menu permissionTree={permissionTree} />
        </Sider>
        <Layout className={styles.contentLayout}>
          <Breadcrumb permissionTree={permissionTree} />
          <Content
            className={styles.content}
            style={{
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
